import type { TValuesTimeseriesPoints } from 'App/Map/types'

export const PRE_FILTER_PRESSURE_VALUE_TYPE =
  'irrigationPressureSemios_preFilter' satisfies TValuesTimeseriesPoints

export const POST_FILTER_PRESSURE_VALUE_TYPE =
  'irrigationPressureSemios_postFilter' satisfies TValuesTimeseriesPoints
